/**
 * RankingSection - Player ranking for Americano
 */
import React from 'react';
import { useTournament } from '../../contexts/TournamentContext';

const MEDALS = ['🥇', '🥈', '🥉'];

const RankingSection = () => {
  const { state } = useTournament();
  const { ranking, tournamentFinished } = state;

  const top3 = ranking.slice(0, 3);

  if (!ranking || ranking.length === 0) {
    return (
      <div className="section-inner">
        <div className="section-header">
          <h1><i className="bi bi-trophy-fill me-3"></i>Classement</h1>
        </div>
        <div className="section-body">
          <div className="alert alert-info">
            Aucun résultat encore saisi. Saisissez les scores dans la section Résultats.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="section-inner">
      <div className="section-header">
        <h1><i className="bi bi-trophy-fill me-3"></i>Classement</h1>
        {tournamentFinished && (
          <p className="lead text-success"><i className="bi bi-flag-fill me-2"></i>Tournoi terminé !</p>
        )}
      </div>

      <div className="section-body">

        {/* Podium top 3 */}
        {top3.length >= 2 && (
          <div className="podium mb-4">
            {top3.map((player, i) => (
              <div key={player.playerId} className={`podium-place place-${i + 1}`}>
                <div className="podium-medal">{MEDALS[i]}</div>
                <div className="podium-name">{player.name}</div>
                <div className="podium-points">{player.totalPoints} pts</div>
              </div>
            ))}
          </div>
        )}

        {/* Full table */}
        <div className="ranking-table-wrapper">
          <table className="table ranking-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Joueur</th>
                <th className="text-center fw-bold">Pts</th>
                <th className="text-center">Matchs</th>
                <th className="text-center">Moy.</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map((player, index) => (
                <tr key={player.playerId} className={index < 3 ? 'fw-semibold' : ''}>
                  <td>
                    {index < 3 ? MEDALS[index] : index + 1}
                  </td>
                  <td>{player.name}</td>
                  <td className="text-center fw-bold text-primary">{player.totalPoints}</td>
                  <td className="text-center">{player.matchesPlayed}</td>
                  <td className="text-center">{player.averagePoints.toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default RankingSection;
